export default __webpack_public_path__ + "static/center-pt-854f81fce7f3fc216c5a60f40b509fa4.webp";